import * as FeatherIcons from 'vue-feather-icons';

export default {
    items: [
        {
            name: 'Dashboard',
            type: 'dashboard',
            route: 'dashboard',
            iconClasses: ['font-icon', 'font-icon-dashboard'],
            iconClass: 'material-icons',
            iconName: 'dashboard',
            color: 'navy',
            group: 'general',
            iconComponent: FeatherIcons.GridIcon,
        },
        {
            name: 'Content',
            children: [
                { name: 'Layouts', route: 'layouts', type: 'layout' },
                { name: 'Pages', route: 'pages?filter=parent_id:$null', type: 'page' },
                { name: 'Panels', route: 'panels', type: 'panel' },
            ],
            iconClass: 'material-icons',
            iconName: 'content_copy',
            color: 'navy',
            group: 'general',
            iconComponent: FeatherIcons.LayersIcon,
        },
        {
            name: 'Assets',
            type: 'asset',
            route: 'assets/0',
            iconClass: 'material-icons',
            iconName: 'perm_media',
            color: 'navy',
            group: 'general',
            iconComponent: FeatherIcons.ImageIcon,
        },
        {
            name: 'Blog',
            iconClass: 'material-icons',
            iconName: 'article',
            route: 'news_posts',
            type: 'news_post',
            color: 'navy',
            group: 'general',
            iconComponent: FeatherIcons.FileTextIcon,
        },
        {
            name: 'Products',
            children: [
                { name: 'Products', route: 'products', type: 'product' },
                { name: 'Categories', route: 'categories', type: 'category' },
                { name: 'Google Taxonomy', route: 'google_taxonomies', type: 'google_taxonomy' },
                { name: 'Variant Groups', route: 'variant_groups', type: 'variant_group' },
                { name: 'Attributes', route: 'product_attributes', type: 'product_attribute' },
                { name: 'Rooms', route: 'product_rooms', type: 'product_room' },
                { name: 'Styles', route: 'product_styles', type: 'product_style' },
                { name: 'Stores', route: 'stores', type: 'store' },
                { name: 'Discount Codes', route: 'discount_codes', type: 'discount_code' },
                { name: 'Discount Ranges', route: 'discount_ranges', type: 'discount_range' },
            ],
            iconClass: 'material-icons',
            iconName: 'store',
            color: 'navy',
            group: 'products',
            iconComponent: FeatherIcons.ShoppingCartIcon,
        },
        {
            name: 'Compliance',
            children: [
                { name: 'Tests', route: 'compliance_tests', type: 'compliance_test' },
                { name: 'Products', route: 'compliance_products', type: 'compliance_product' },
            ],
            group: 'compliance',
            color: 'navy',
            iconComponent: FeatherIcons.CheckCircleIcon,
        },
        {
            name: 'Customers',
            children: [
                { name: 'Customers', route: 'customers', type: 'customer' },
                { name: 'Customer Email Templates', route: 'customer_emails', type: 'customer_email' },
            ],
            iconClass: 'material-icons',
            iconName: 'perm_contact_calendar',
            color: 'navy',
            group: 'customer',
            iconComponent: FeatherIcons.UsersIcon,
        },
        {
            name: 'Orders',
            route: 'orders',
            type: 'order',
            iconClass: 'material-icons',
            iconName: 'assignment',
            color: 'navy',
            group: 'customer',
            iconComponent: FeatherIcons.ShoppingBagIcon,
        },
        {
            name: 'Quotes',
            children: [
                { name: 'Store Quotes', route: 'quotes_stores', type: 'quotes_store' },
                { name: 'Electrical Contractor Quotes', route: 'quotes_platinums', type: 'quotes_platinum' },
                { name: 'Customer Quotes', route: 'quotes_customers', type: 'quotes_customer' },
                { name: 'Quote Email Templates', route: 'quote_emails', type: 'quote_email' },
            ],
            iconClass: 'material-icons',
            iconName: 'request_quote',
            color: 'navy',
            group: 'customer',
            iconComponent: FeatherIcons.DollarSignIcon,
        },
        {
            name: 'Enquiries',
            children: [
                { name: 'Enquiries', route: 'enquiries', type: 'enquiry' },
                { name: 'Subscribers', route: 'subscribers', type: 'subscriber' },
                { name: 'Applications', route: 'applications', type: 'application' },
                { name: 'Promotions', route: 'promotions', type: 'promotion' },
                { name: 'Warranty Claims', route: 'warranties', type: 'warranty' },
                { name: 'Downloads', route: 'downloads', type: 'download' },
                { name: 'Consultations', route: 'consultations', type: 'consultation' },

            ],
            iconClass: 'material-icons',
            iconName: 'forum',
            color: 'navy',
            group: 'customer',
            iconComponent: FeatherIcons.MessageSquareIcon,
        },
        {
            name: 'Careers',
            iconClass: 'material-icons',
            iconName: 'perm_contact_calendar',
            color: 'navy',
            group: 'customer',
            children: [
                { name: 'Careers', route: 'careers', type: 'career' },
                { name: 'Career Applications', route: 'career_applications', type: 'career_application' },
            ],
            iconComponent: FeatherIcons.BriefcaseIcon,
        },
        {
            name: 'Feedback',
            children: [
                { name: 'Feedback', route: 'feedback', type: 'feedback' },
                { name: 'Feedback Email Templates', route: 'feedback_emails', type: 'feedback_email' },
            ],
            iconClass: 'material-icons',
            iconName: 'perm_contact_calendar',
            color: 'navy',
            group: 'customer',
            iconComponent: FeatherIcons.RadioIcon,
        },
        {
            name: 'Reports',
            iconClass: 'material-icons',
            iconName: 'assignment',
            color: 'navy',
            group: 'reporting',
            children: [
                { name: 'Order', type: 'order_report', route: 'order_reports' },
                { name: 'Product', type: 'product_report', route: 'product_reports' },
            ],
            iconComponent: FeatherIcons.BarChart2Icon,
        },
        {
            name: 'Accounts',
            children: [
                { name: 'Users', route: 'users', type: 'user' },
                { name: 'Roles', route: 'roles', type: 'role' },
            ],
            group: 'settings',
            iconClass: 'material-icons',
            iconName: 'account_box',
            color: 'navy',
            iconComponent: FeatherIcons.LockIcon,
        },
        {
            name: 'Settings',
            children: [
                { name: 'Settings', route: 'settings', type: 'setting' },
                { name: 'Maintenance', route: 'setting/2#maintenance', type: 'setting' },
                { name: 'Redirect URLs', route: 'redirect_urls', type: 'redirect_url' },
            ],
            group: 'settings',
            iconClass: 'material-icons',
            iconName: 'settings',
            color: 'navy',
            iconComponent: FeatherIcons.SettingsIcon,
        },
    ],
    defaultItem: 'Content',
}